export enum EnergyType {
  electricity = 'electricity',
  gas = 'gas'
}
